import {AjaxStatusCore, WebserviceCore} from "dts-react-common";
import config from "./Config";
import * as shared from "../common/Shared";
import {showMessage} from "../common/Shared";
import reduxStore from "./ReduxStore";
import {iconWarning} from "../common/Icon";
import {dispatchField} from "../common/Dispatch";

export const ajaxStatusCore = new AjaxStatusCore();
const webserviceCore = new WebserviceCore({
    // mocked url that just returns some content
    baseUrl: config.baseWebserviceUrl,
    ajaxStatusCore: ajaxStatusCore,
    jsLogging: undefined,
    allResultsCallback: data => {
        // pull out roles and check error message
        if (data.errors && data.errors.length) {
            data.errors.forEach((value) => {
                const message = {
                    title: 'Web Service Error',
                    message: value,
                    icon: iconWarning
                };
                shared.dispatchUpdateData({field: 'messages', value: reduxStore.getState().messages.concat(message)});
            });
        } else if (!data.roles) {
            const message = {
                title: 'Authentication Error',
                message: 'Call did not return updated security',
                icon: iconWarning
            };
            shared.dispatchUpdateData({field: 'messages', value: reduxStore.getState().messages.concat(message)});
        } else {
            shared.dispatchUpdateData({path: 'account', field: 'roles', value: data.roles});
        }
        return data && data.data;
    },
    loadDefaultsCallback: defaults => defaults.headers.common['Authorization'] = reduxStore.getState().oidc.user && reduxStore.getState().oidc.user.access_token,
});

const webserviceHRIS = new WebserviceCore({
    baseUrl: config.baseWebserviceUrlHRIS,
    ajaxStatusCore: ajaxStatusCore,
    loadDefaultsCallback: defaults => {
        delete defaults.headers.common['Authorization'];
        defaults.withCredentials = false;
    },
});

export const WEBSERVICE_AJAX_ID = {
    GET_OFFER: 'GET_OFFER'
};

function dispatchListDataFieldCurry(listName) {
    return list => dispatchField(`dataList.${listName}`, list.map(item => ({label: item.name, value: item.fk})));
}

const webservice = {
    user: {
        get: () => webserviceCore.get('user'),
    },
    handleError: {
        sendError: error => webserviceCore.post('error.json', error),
    },

    offer: {
        save: offer => webserviceCore.post('offer/save', offer)
            .then(offer => {
                shared.dispatchUpdateData({path: 'app', field: 'offer', value: offer});
                return offer;
            }),
        reject: offer => webserviceCore.post('offer/reject', offer),
        accept: offer => webserviceHRIS.get(`offerAcceptance/acceptOffer/${offer.positionPlacementPk}.json`, {withCredentials: false})
            .then(result => {
                if (result && result !== 'success') {
                    console.error(result);
                    showMessage('Unable to accept offer', 'There was an error accepting this offer. Please contact your hiring manager to have this resolved.');
                    throw result;
                }
            }),
        get: guid => webserviceCore.get(`offer/get/${guid}`, undefined, WEBSERVICE_AJAX_ID.GET_OFFER).then(offer => {
            if (offer.hiringStatusFk === 2) {
                shared.dispatchUpdateData({path: 'app', field: 'accepted', value: true});
            } else if (offer.hiringStatusFk === shared.REJECTION_REASON_FKS.LOCATION ||
                offer.hiringStatusFk === shared.REJECTION_REASON_FKS.OTHER ||
                offer.hiringStatusFk === shared.REJECTION_REASON_FKS.SALARY) {
                shared.dispatchUpdateData({path: 'app', field: 'rejected', value: true});
            }

            if (offer.socialSecurityNumber && offer.socialSecurityNumber.length === 9) {
                offer.socialSecurityNumber = `${offer.socialSecurityNumber.substr(0, 3)}-${offer.socialSecurityNumber.substr(3, 2)}-${offer.socialSecurityNumber.substr(5)}`;
            }
            shared.dispatchUpdateData({path: 'app', field: 'offer', value: offer});
            return offer;
        }),
    },

    dataLists: () => webserviceCore.get('data/listAll').then(lists => Object.keys(lists).forEach(key => dispatchField(`dataList.${key}`, lists[key].map(item => ({
        label: item.name,
        value: item.fk
    }))))),

    corrections: {
        send: corrections => webserviceCore.post('corrections/save', corrections),
    },
};

export default webservice;
